@if (isEmpty) {
  <div ngClass.gt-md="container" class="container">
    <div id="noProducts" fxLayout="row" fxLayoutAlign="center center">
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <div>
          <img src="assets/images/no-product.png" alt="no-product">
        </div>
        <div class="notFound">
          <span>Sorry, no results found! </span>
        </div>
        <div class="spell">
          <span fxLayoutAlign="center center">Please check the spelling or try searching for something else </span>
        </div>
      </div>
    </div>
  </div>
}
@if (list.length>0) {
  <div ngClass.gt-md="container" ngClass.md="container" id="productsPage">
    <div class="inner-container ">
      @if (!isEmpty) {
        <div>
          <div fxLayout="row wrap">
            @if (!isEmpty) {
              <div fxFlex.lt-md="100" fxFlex.gt-sm class="all-products padding-2"
                >
                @if (!mobileScreen) {
                  <div style="padding: 0px 10px;" fxHide fxShow.md fxShow.gt-md fxShow.lg fxShow.xl
                    fxLayout="row wrap" class="products-wrapper  " id="list">
                    @for (blogObject of list | paginate: config; track blogObject) {
                      <div
                        fxFlex.xs="50" [fxFlex.lg]="viewCol"
                        [fxFlex.gt-sm]="viewCol" fxFlex.lt-md="33.33" class="border-lb" class="col product-mobile backg">
                        <calsoft-blog-layout  [bloglayouttype]="blogType" [data]="data" [blog]="blogObject">
                        </calsoft-blog-layout>
                      </div>
                    }
                  </div>
                }
                @if (mobileScreen) {
                  <div id="list" style="padding: 0px 10px;" fxHide fxShow.lt-sm fxShow.sm fxShow.md
                  [fxLayout]="blogType === 1 ? 'column' : 'row wrap'" class="products-wrapper ">
                    @for (blogObject of list ; track blogObject) {
                      <div [fxFlex.xs]="blogType === 1 ? '100' : '50'" 
                        [fxFlex.lg]="viewCol" [fxFlex.gt-sm]="viewCol"
                         class="border-lb" class="col product-mobile backg">
                        <calsoft-blog-layout [bloglayouttype]="blogType"   [data]="data" [blog]="blogObject">
                        </calsoft-blog-layout>
                      </div>
                    }
                  </div>
                }
                @if (!isEmpty) {
                  <div fxHide fxShow.gt-sm fxLayout="row wrap">
                    <div fxFlex="100">
                      <div class="product-elevation text-center">
                        <pagination-controls class="product-pagination" [autoHide]="false" (pageChange)="onPageChanged($event)">
                        </pagination-controls>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (list.length <= count) {
  <div fxHide fxShow.lt-sm>
    <div class="search-results" infiniteScroll (scrolled)="onScroll()">
      @if (spinner !=false) {
        <div fxLayout=row fxLayoutAlign="center center">
          <mat-spinner [diameter]="20"></mat-spinner>
          <!-- <mat-spinner  *ngIf="this.list.length==this.count"></mat-spinner> -->
        </div>
      }
    </div>
  </div>
}

<!-- <div fxHide fxShow.lt-md fxLayout=row class="padding-10"
*ngIf="list.length==count"
fxLayoutGap="10px" fxLayoutAlign="center center">

<p>No more Blogs</p>


</div> -->





@if (spinnerMain !=false) {
  <div fxLayout="row" fxLayoutAlign="center center" class="overlay">
    <mat-spinner color="primary" [diameter]="45" class="spinner">
    </mat-spinner>
  </div>
}
